import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import toast from "react-hot-toast";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(form.email, form.password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate(next);
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <p className="label-eyebrow mb-3">Account</p>
      <h1 className="font-serif text-5xl tracking-tighter mb-10">Sign in</h1>

      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="label-eyebrow block mb-2">Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="aj-input" data-testid="login-email-input" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Password</label>
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="aj-input" data-testid="login-password-input" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="login-submit-btn">{loading ? "Signing in…" : "Sign In"}</button>
      </form>

      <p className="mt-8 text-sm text-[#6A747D] text-center">
        New here? <Link to="/register" className="underline underline-offset-4 hover:text-[#333E48]" data-testid="login-register-link">Create an account</Link>
      </p>
    </div>
  );
}
